/**
 * record-categories — wspólne słownictwo kluczy kartotek niosących oś „Kategoria".
 *
 * JEDNO źródło prawdy dla `kartoteka_key` osi kategorii, współdzielone przez:
 *  - apps/api (`lib/records/categories.ts`) — allowlista walidacji zapisu,
 *  - apps/admin (`lib/record-categories.ts`) — lista kartotek z UI (typowany PODZBIÓR).
 *
 * Dzięki temu obie strony spellują nazwy z jednego miejsca: literówka albo usunięcie klucza
 * po jednej stronie = błąd kompilacji, nie cichy rozjazd list. Backend przyjmuje kategorię dla
 * KAŻDEGO z tych kluczy; front listuje tylko te, które mają już wpięte UI (świadomy podzbiór).
 *
 * NIE mylić z „grupami" (wiele na rekord, ze słownika — `lib/records/groups.ts`).
 */
export const RECORD_CATEGORY_KARTOTEKA_KEYS = [
  'contractors',
  'companies',
  'employees',
  'users',
  'products',
  'contractor_contacts',
  'documents',
  'tasks',
] as const;

export type RecordCategoryKartotekaKey = (typeof RECORD_CATEGORY_KARTOTEKA_KEYS)[number];

export function isRecordCategoryKartotekaKey(key: string): key is RecordCategoryKartotekaKey {
  return (RECORD_CATEGORY_KARTOTEKA_KEYS as readonly string[]).includes(key);
}
